import {
  AutoComplete,
  Button,
  Card,
  Col,
  HeadingThree,
  HorizontalRule,
  Paragraph,
  PostcodeAutocomplete,
  Row
} from 'hui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { EventActions, EventCategories, EventLabels } from '../../../constants/Analytics';

export default class GetQuotesWidget extends Component<any, any> {
  static propTypes = {
    classPrefix: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    category: PropTypes.object,
    categoryPersonPlural: PropTypes.string,
    submitSelection: PropTypes.func
  };

  static defaultProps = {
    classPrefix: 'gq-postcode',
    categoryPersonPlural: 'Trade Professionals',
    name: 'gq-postcode',
    value: '',
    placeholder: 'Enter postcode'
  };

  state = {
    postcodeValue: ''
  };

  onChange = postcodeValue => {
    this.setState({ postcodeValue });
  };

  onSuggestionSelected = (event, { suggestion }) => {
    const postcodeValue = `${suggestion.postcode} - ${suggestion.suburb}`;
    this.setState({ postcodeValue: postcodeValue });
    this.submitAction(postcodeValue);
  };

  onButtonClick = e => {
    e.preventDefault();

    this.submitAction(this.state.postcodeValue);
  };

  submitAction = value => {
    const { submitSelection, category } = this.props;

    submitSelection(value, category, 'widget');
  };

  render() {
    const { postcodeValue } = this.state;
    const { classPrefix, placeholder, name, categoryPersonPlural } = this.props;

    return (
      <Card color="tint1" mb={3} p={1}>
        <HeadingThree tag={'p'} m={0} color="tint6">
          Find great {categoryPersonPlural.toLowerCase()}
        </HeadingThree>
        <HorizontalRule width={'40px'} />
        <Paragraph color="tint6">
          Get up to 3 free quotes. Compare and choose the best professional for your job.
        </Paragraph>
        <Row>
          <Col xs={12} md={4}>
            <AutoComplete classPrefix={classPrefix}>
              <PostcodeAutocomplete
                classPrefix={classPrefix}
                value={postcodeValue}
                name={name}
                placeholder={placeholder}
                onChange={this.onChange}
                onSuggestionSelected={this.onSuggestionSelected}
              />
            </AutoComplete>
          </Col>
          <Col xs={12} md={3}>
            <Button
              tag="a"
              block
              href="/get_quotes_simple"
              color="primary"
              data-ga-category={EventCategories.ARTICLES}
              data-ga-action={EventActions.GET_QUOTES_WIDGET_CLICK_BUTTON}
              data-ga-label={EventLabels.GET_QUOTES_WIDGET_CLICK_BUTTON}
              onClick={this.onButtonClick}
            >
              Get Quotes
            </Button>
          </Col>
        </Row>
      </Card>
    );
  }
}
